import PropTypes from 'prop-types'
import React, { Fragment, useEffect, useState } from "react"

import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label, Spinner } from "reactstrap";

// Redux
import { withRouter, Link } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

//Social Media Imports
// import { GoogleLogin } from "react-google-login"
// import TwitterLogin from "react-twitter-auth"
// import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props"

// actions
import { loginUser, resetPassword
  // ,socialLogin
 } from "../../store/actions"
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

// import images
// import logo from "../../assets/images/logo-dark.png"
// import logolight from "../../assets/images/logo-light.png"

//Import config
// import { facebook, google } from "../../config"

const RecoveredPassword = (props) => {

  const dispatch = useDispatch();
  const {token} = useParams()
  const [notMatching,setNotMatching] = useState(false)
  const success = useSelector(state=>state?.Login?.success)
  console.log(success)
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      password: '',
      confirmPassword: '',
    },
    validationSchema: Yup.object({
      password: Yup.string().required("Please Enter Your new password"),
      confirmPassword: Yup.string().oneOf([Yup.ref('password')], 'Password not matching').required("Please Enter Your confirm Password"),
      
    }),
    onSubmit: (values) => {
 
      if(values.password != values.confirmPassword){
      setNotMatching(true)
      }else{
      dispatch(resetPassword({password:values.password,token}, props.history));
      }

    }
  });

  const { error } = useSelector(state => ({
    error: state.Login.error,
  }));
  const loading = useSelector(state => state.Login.loading)


  useEffect(() => {
    document.body.className = "authentication-bg";
    // remove classname when component will unmount
    return function cleanup() {
      document.body.className = "";
    };
  });
  return (
    <React.Fragment>
      {/* {
        success ? <Label>password changed</Label>
        : */}
<div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="text-center">
                {/* <Link to="/" className="mb-5 d-block auth-logo">
                  <img src={logo} alt="" height="22" className="logo logo-dark" />
                  <img src={logolight} alt="" height="22" className="logo logo-light" />
                </Link> */}
              </div>
            </Col>
          </Row>
          <Row className="align-items-center justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card>
                <CardBody className="p-4">
                  <div className="text-center mt-2">
                    <h5 className="text-primary">Welcome Back !</h5>
                    <p className="text-muted">Reset your password.</p>
                  </div>
                  <div className="p-2 mt-4">
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                       {error ? <Alert color="danger">{error}</Alert> : null}
                       {validation.errors.confirmPassword ? <Alert color="danger">{'Password not matching'}</Alert> : null}
                       {success? <Alert color="success">{'Password changed'}</Alert> : null}
{
  !success ? 
  <Fragment>
  <div className="mb-3">
                        <Label className="form-label">New password</Label>
                        <Input
                          name="password"
                          className="form-control"
                          placeholder="Enter password"
                          type="password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.password || ""}
                          invalid={
                            validation.touched.password && validation.errors.password ? true : false
                          }
                        />
                        {validation.touched.password && validation.errors.password ? (
                          <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
  
                        <Label className="form-label">Confirm Password</Label>
                        <Input
                          name="confirmPassword"
                          value={validation.values.confirmPassword || ""}
                          type="password"
                          placeholder="Enter confirmPassword"
                          onChange={(e)=>{setNotMatching(false); validation.setFieldValue('confirmPassword',e.target.value)}}
                          onBlur={validation.handleBlur}
                          
                          invalid={
                            validation.touched.confirmPassword && validation.errors.confirmPassword ? true : false
                          }
                        />
                        {validation.touched.confirmPassword && validation.errors.confirmPassword ? (
                          <FormFeedback type="invalid">{validation.errors.confirmPassword}</FormFeedback>
                        ) : null}
                      </div>

          

                      <div className="mt-3 d-flex justify-content-center flex-nowrap">
                        {
                          loading ? 
                          <Spinner type="grow" className="m-1" color="primary" />
                          :
                            <button
                          className="btn btn-primary w-100 waves-effect waves-light"
                          type="submit"
                          // disabled={loading}
                        >
                          Save
                        </button>
                        }
                      
                      </div>

                     

                 
  </Fragment>
  :null
  
}
</Form>

</div>
</CardBody>
</Card>

</Col>
</Row>

</Container>
</div>
                     
      {/* } */}
      
    </React.Fragment>
  )
}

export default withRouter(RecoveredPassword);

RecoveredPassword.propTypes = {
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func,
  socialLogin: PropTypes.func
}